import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=ac241982&scoped=true"
var script = {}
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=ac241982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac241982",
  null
  
)

export default component.exports